import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getNotificationList as getNotificationListApi,
	getNotification as getNotificationApi,
	addNewNotification as addNewNotificationApi,
	addNewBulkNotification as addNewBulkNotificationApi,
	updateNotification as updateNotificationApi,
	deleteNotification as deleteNotificationApi, 
	readNotification as readNotificationApi, 
	readBulkNotification as readBulkNotificationApi, 
} from '../../helpers/message/backend_helper';

export const getNotificationList = createAsyncThunk('notifications/getNotificationList', async (params) => {
	try { 
		const response = getNotificationListApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getNotification = createAsyncThunk('notifications/getNotification', async notification_id => {
	try {
		const response = getNotificationApi(notification_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewNotification = createAsyncThunk('notifications/addNewNotification', async notification => {
	try {
		const response = addNewNotificationApi(notification); 
		return response;
	} catch (error) {
		toast.error('Error al agregar notification.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const addNewBulkNotification = createAsyncThunk('notifications/addNewBulkNotification', async (notification) => {
	try { 
		const response = addNewBulkNotificationApi(notification); 
		return response;
	} catch (error) {
		toast.error('Error al agregar notification.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateNotification = createAsyncThunk('notifications/updateNotification', async (notification) => {
		try {
			const response = updateNotificationApi(notification); 
			return response;
		} catch (error) {
			toast.error('Error al actualizar notification.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const readNotification = createAsyncThunk('notifications/readNotification', async notification_id => {
		try {
			const response = readNotificationApi(notification_id); 
			return response;
		} catch (error) {
			toast.error('Error al actualizar notification.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const readBulkNotification = createAsyncThunk('notifications/readBulkNotification', async (notification) => {
		try {
			const response = readBulkNotificationApi(notification); 
			return response;
		} catch (error) {
			toast.error('Error al actualizar notification.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteNotification = createAsyncThunk('notifications/deleteNotification', async notification => {
	try {
		const response = await deleteNotificationApi(notification); 
		return { notification, ...response };
	} catch (error) {
		toast.error('Error al eliminar notification.', { autoClose: 3000 });
		throw new Error(error);
	}
});

